export default "assets/images/icons/scroll-top-165e85b8.svg";